import React, { useState, useEffect } from "react";
import { MDBRow, MDBCol, MDBInput, MDBBtn, MDBContainer } from "mdbreact";

import Axios from "axios";

import "react-datepicker/dist/react-datepicker.css";

import WarningBox from "../components/WarningBox";

import { toast, ToastContainer } from "mdbreact";
import Select from "react-select";
const AddEditCustomer = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  const serverURL = props.apiServer;

  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [frm, setValues] = useState({
    code: "new",
    lastname: "",
    firstname: "",
    middlename: "",
    nameext: "",
    mobilenumber: "",
    address: "",

    deleted: false,
    datecreated: new Date(),
    usercode: sessionStorage.getItem("Email"),
    usertoken: sessionStorage.getItem("msal.uc"),
  });

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;

      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    savecustomer();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const loadcustomerdetails = () => {
    Axios.get(
      props.apiServer + "/loadcustomerdetails?acode=" + props.code,
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setValues({
            ...frm,
            code: props.code,

            lastname: res.data.lastname,
            firstname: res.data.firstname,
            middlename: res.data.middlename,
            nameext: res.data.nameext,
            mobilenumber: res.data.mobilenumber,
            address: res.data.address,
            usercode: res.data.usercode,
            deleted: res.data.deleted,
          });
        } else {
          console.log("No record");
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        // toggleWarningBox();
        console.log(error);
      });
  };

  const savecustomer = () => {
    const data = frm;

    Axios.post(props.apiServer + "/savecustomer", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });

          toast.info(res.data.message, {
            closeButton: false,
          });
          if (props.quicktool === "yes") {
            props.toggleModal();
          } else if (props.quickadd === "yes") {
            props.toggleModal2();
          } else {
            props.refreshGrid();
          }
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  useMountEffect(loadcustomerdetails);

  return (
    <React.Fragment>
      <MDBContainer fluid>
        <MDBRow>
          <MDBCol md="10">
            <form
              className="needs-validation"
              onSubmit={submitHandler}
              noValidate
            >
              <MDBRow hidden>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.code}
                    id="code"
                    label="code"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.lastname}
                    id="lastname"
                    label="Last Name"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.firstname}
                    id="firstname"
                    label="First Name"
                    onChange={updateField}
                    required
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.middlename}
                    id="middlename"
                    label="Middle Name"
                    onChange={updateField}
                  ></MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.nameext}
                    id="nameext"
                    label="Name Ext"
                    onChange={updateField}
                  ></MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.mobilenumber}
                    id="mobilenumber"
                    label="Mobile Number"
                    onChange={updateField}
                    required
                  ></MDBInput>
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.address}
                    id="address"
                    label="Address"
                    onChange={updateField}
                  ></MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.usercode}
                    id="usercode"
                    label="Email Address"
                    onChange={updateField}
                  ></MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="12">
                  <MDBInput
                    id="deleted"
                    label="Is Deleted"
                    type="checkbox"
                    checked={frm.deleted}
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="12">
                  <MDBBtn className="blue lighten-1" type="submit">
                    Save
                  </MDBBtn>
                  {props.quicktool === "yes" ? (
                    <>
                      <MDBBtn
                        id="cmdClose"
                        className="blue lighten-4 blue-text"
                        onClick={props.toggleModal}
                      >
                        Close this
                      </MDBBtn>
                      <MDBBtn
                        id="cmdClose"
                        className="orange lighten-4 black-text"
                        onClick={props.toggleModal2}
                      >
                        Back to Customer Ticket
                      </MDBBtn>
                    </>
                  ) : (
                    ""
                  )}
                  {props.quickadd === "yes" ? (
                    <>
                      <MDBBtn
                        id="cmdClose"
                        className="blue lighten-4 blue-text"
                        onClick={props.toggleModal2}
                      >
                        Close this
                      </MDBBtn>
                    </>
                  ) : (
                    ""
                  )}

                  {/* {props.code === "" ? (
                    <MDBBtn
                      id="cmdClose"
                      className="blue lighten-4 blue-text"
                      onClick={props.toggleModal}
                    >
                      Close
                    </MDBBtn>
                  ) : (
                    ""
                  )} */}
                </MDBCol>
                <MDBCol md="6"></MDBCol>
              </MDBRow>
            </form>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={5000}
      />

      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default AddEditCustomer;
